'use client';

import { c as _c } from "react/compiler-runtime";
import { TERMOS_ATUALIZACAO, TERMOS_SECOES, TERMOS_VIGENCIA } from '../constants';
import type { UseNotificacaoSelfReturn } from '../hooks';
import { BackHeader } from './BackHeader';
interface TermosScreenProps {
  vm: UseNotificacaoSelfReturn;
}
export const TermosScreen = t0 => {
  const $ = _c(6);
  const {
    vm
  } = t0;
  let t1;
  if ($[0] !== vm) {
    t1 = <BackHeader onVoltar={() => vm.goTo("cadastro")} />;
    $[0] = vm;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="top-6 flex flex-col gap-1 md:sticky md:h-fit md:basis-[260px]"><span className="mb-2 text-[11px] font-bold tracking-wider text-neutral-500 uppercase">Capítulos</span>{TERMOS_SECOES.map(_temp)}</div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="mx-auto flex w-full max-w-[1200px] flex-1 flex-col gap-10 px-6 py-10 md:flex-row md:gap-16 md:px-20 md:py-12">{t2}<div className="flex max-w-[720px] flex-1 flex-col gap-8"><div><span className="text-[13px] text-neutral-500">Data da última atualização: {TERMOS_ATUALIZACAO} · Data de vigência: {TERMOS_VIGENCIA}</span><h1 className="text-heading-dark mt-1 mb-2 text-2xl font-semibold sm:text-[28px]">Termos Gerais de Uso da Arbitralis</h1><p className="text-[15px] leading-relaxed text-neutral-700">Leia com atenção. A aceitação destes Termos é condição para acessar a Plataforma e utilizar os Serviços, e implica o conhecimento da Política de Privacidade.</p></div>{TERMOS_SECOES.map(_temp3)}</div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1) {
    t4 = <div className="flex min-h-screen w-full flex-col bg-white">{t1}{t3}</div>;
    $[4] = t1;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
function _temp(secao, index) {
  return <a key={secao.id} href={`#${secao.id}`} className="text-label-muted hover:text-brand-600 py-1.5 text-[13px] transition-colors">{index + 1}. {secao.titulo}</a>;
}
function _temp2(paragrafo, indice) {
  return <span key={indice} className="text-[15px] leading-relaxed text-neutral-700">{paragrafo}</span>;
}
function _temp3(secao_0, index_0) {
  return <div key={secao_0.id} id={secao_0.id} className="flex scroll-mt-24 flex-col gap-3 border-t border-solid border-neutral-200 pt-6"><span className="text-heading-dark text-lg font-bold">{index_0 + 1}. {secao_0.titulo}</span>{secao_0.corpo.map(_temp2)}</div>;
}